/** Only seed-registration 409s mean the stitched seed is not available yet. */
export function isLereSeedRegistrationPending(error: unknown): boolean {
  if (!error || typeof error !== 'object') return false

  return ('status_code' in error && error.status_code === 409) || ('status' in error && error.status === 409)
}
